import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Table, Button, Badge, Row, Col, Container, ProgressBar } from 'react-bootstrap';
import { getStatusBadgeClass } from './campaignUtils';
import CampaignWizard from './Wizard/CampaignWizard';
import './WhatsappCampaignManager.scss';

const CampaignDashboard = () => {
    const history = useHistory();
    const [showWizard, setShowWizard] = useState(false);
    
    // Mock campaigns data
    const [campaigns] = useState([
        { id: 1, name: 'March Mid-Term Invite', status: 'Completed', attempted: 1200, sent: 1180, delivered: 1150, read: 980, failed: 20 },
        { id: 2, name: 'Holiday Greetings', status: 'Scheduled', attempted: 500, sent: 0, delivered: 0, read: 0, failed: 0 },
        { id: 3, name: 'Fee Reminder - Q1', status: 'In Process', attempted: 2000, sent: 1540, delivered: 1400, read: 800, failed: 60 }
    ]);

    const handleCreateCampaign = () => {
        setShowWizard(true);
    };

    return (
        <Container fluid className="px-0 wcm-wrapper">
            <div className="d-flex justify-content-between align-items-center mb-4 px-3 pt-3">
                <div>
                    <h3 className="font-weight-bold text-dark mb-1">WhatsApp Campaigns</h3>
                    <p className="text-muted small">Manage and track your automated message broadcasts.</p>
                </div>
                <div className="d-flex">
                    <Button 
                        variant="outline-primary" 
                        className="px-4 mr-2 shadow-sm font-weight-bold rounded-pill"
                        onClick={() => history.push('/whatsapp-messaging')}
                    >
                        <i className="fas fa-comments mr-2" /> LIVE CHAT
                    </Button>
                    <Button variant="primary" onClick={handleCreateCampaign} className="px-4 shadow-sm font-weight-bold rounded-pill">
                        <i className="fas fa-plus-circle mr-2" /> CREATE NEW CAMPAIGN
                    </Button>
                </div>
            </div>

            {/* Metrics Overview */}
            <Row className="mb-4 px-2">
                <Col md={3} className="mb-3">
                    <Card className="wcm-metric-card shadow-sm p-4 border-left-primary">
                        <div className="metric-label">TOTAL CAMPAIGNS</div>
                        <div className="metric-value">12</div>
                    </Card>
                </Col>
                <Col md={3} className="mb-3">
                    <Card className="wcm-metric-card shadow-sm p-4">
                        <div className="metric-label">TOTAL SENT</div>
                        <div className="metric-value text-primary">45.2K</div>
                    </Card>
                </Col>
                <Col md={3} className="mb-3">
                    <Card className="wcm-metric-card shadow-sm p-4">
                        <div className="metric-label">READ RATE</div>
                        <div className="metric-value text-success">82%</div>
                    </Card>
                </Col>
                <Col md={3} className="mb-3">
                    <Card className="wcm-metric-card shadow-sm p-4">
                        <div className="metric-label">FAILURE RATE</div>
                        <div className="metric-value text-danger">1.4%</div>
                    </Card>
                </Col>
            </Row>

            {/* Campaign List */}
            <div className="px-3">
                <Card className="border-0 shadow-sm rounded-lg overflow-hidden">
                    <Card.Header className="bg-white border-bottom py-3">
                        <h6 className="m-0 font-weight-bold text-dark">Active Campaigns</h6>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Table responsive hover className="mb-0 align-middle">
                            <thead className="bg-light text-muted small font-weight-bold">
                                <tr>
                                    <th className="border-0 px-4 py-3">CAMPAIGN NAME</th>
                                    <th className="border-0 py-3">STATUS</th>
                                    <th className="border-0 py-3 text-center">ATTEMPTED</th>
                                    <th className="border-0 py-3 text-center">SENT</th>
                                    <th className="border-0 py-3 text-center text-success">DELIVERED</th>
                                    <th className="border-0 py-3 text-center">READ</th>
                                    <th className="border-0 px-4 py-3 text-right">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {campaigns.map(c => (
                                    <tr key={c.id}>
                                        <td className="px-4 py-3 font-weight-bold text-dark">{c.name}</td>
                                        <td>
                                            <Badge className={`px-2 py-1 ${getStatusBadgeClass(c.status)}`} style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
                                                {c.status.toUpperCase()}
                                            </Badge>
                                        </td>
                                        <td className="text-center font-weight-500 text-muted">{c.attempted.toLocaleString()}</td>
                                        <td className="text-center font-weight-bold text-primary">{c.sent.toLocaleString()}</td>
                                        <td className="text-center font-weight-bold text-success">{c.delivered.toLocaleString()}</td>
                                        <td className="text-center font-weight-bold text-info">{c.read.toLocaleString()}</td>
                                        <td className="px-4 text-right">
                                            <Button variant="light" size="sm" className="rounded-circle mr-2 text-primary shadow-none border" title="View Analytics">
                                                <i className="fas fa-chart-line" />
                                            </Button>
                                            <Button variant="light" size="sm" className="rounded-circle text-muted shadow-none border" title="Download Report">
                                                <i className="fas fa-download" />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>

            {/* Create Campaign Wizard */}
            {showWizard && (
                <CampaignWizard 
                    show={showWizard} 
                    onHide={() => setShowWizard(false)} 
                />
            )}
        </Container>
    );
};

export default CampaignDashboard;
